import React, { useState } from 'react';
import { Occupation } from '../types';
import { Icon } from '@/components/Icon';
import tagularEvent from '@/utils/tagular/tagularEvent';
import uuid from '@/utils/uuid';

interface SalaryInsightsProps {
  selectedOccupationCard: Occupation | null;
}

const SalaryInsights: React.FC<SalaryInsightsProps> = ({
  selectedOccupationCard,
}) => {
  const [salaryInsightsExpanded, setSalaryInsightsExpanded] =
    useState<boolean>(false);

  const handleSalaryInsightsClick = () => {
    // Fire the element clicked event first
    tagularEvent('ElementClicked', {
      correlationId: uuid(),
      webElement: {
        elementType: 'button',
        location: 'salary-calculator',
        name: 'salary-insights',
        position: '',
        text: salaryInsightsExpanded
          ? 'Collapse Salary Insights'
          : 'Expand Salary Insights',
      },
    });

    setSalaryInsightsExpanded(!salaryInsightsExpanded);
  };
  return (
    selectedOccupationCard && (
      <div className='bg-white rounded-lg shadow p-4 border border-gray-100'>
        <div
          className='flex items-center hover:cursor-pointer'
          onClick={() => handleSalaryInsightsClick()}
        >
          <svg
            className='w-5 h-5 text-blue-500 mr-2'
            fill='currentColor'
            viewBox='0 0 20 20'
          >
            <path d='M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 6.464A1 1 0 106.464 5.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM5 10a1 1 0 01-1 1diva1 1 0 110-2h1a1 1 0 011 1zM8 16v-1h4v1a2 2 0 11-4 0zM12 14c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.476.859h4.002z' />
          </svg>
          <div className='font-bold'>Salary Insights</div>
          <Icon
            icon='chevron-down'
            className={`ml-auto cursor-pointer ${salaryInsightsExpanded ? 'rotate-180' : ''}`}
          />
        </div>
        {selectedOccupationCard &&
          selectedOccupationCard.title &&
          selectedOccupationCard.employmentChange && (
            <ul
              className={`space-y-4 text-gray-700 mt-4 list-disc ${salaryInsightsExpanded ? 'block' : 'hidden'}`}
            >
              <li className='flex items-start'>
                <p className='font-body-14'>
                  The projected employment change for{' '}
                  {selectedOccupationCard?.title} is{' '}
                  {selectedOccupationCard?.employmentChange}%.
                </p>
              </li>
              <li className='flex items-start'>
                <p className='font-body-12 font-normal'>
                  This tool is powered by data from the Occupational Information
                  Network <a href='https://www.onetcenter.org/'>(O*NET)</a>, a
                  database developed by the U.S. Department of Labor,
                  Employment, and Training Administration.
                </p>
              </li>
            </ul>
          )}
      </div>
    )
  );
};
export default SalaryInsights;
